// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"Banner_closeButton__EH_Ld","content":"Banner_content__hYhbR","wrapper":"Banner_wrapper___WInn"};